import * as React from 'react'


interface ArticleProps {
  article: any
  onClick: (id: number) => void
}

interface ArticleState {

}

class Article extends React.Component<ArticleProps, ArticleState> {

  handleArticleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    this.props.onClick(this.props.article.id)
  }

  handleArticleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.props.onClick(this.props.article.id)
    }
  }

  render () {
    return (
      <li
        className='list-group-item'
        onClick={this.handleArticleClick}
        role='link'
        tabIndex={0}
        onKeyDown={this.handleArticleKeyDown}
      >
        <span className='answers-popular-item-header'>{this.props.article.text}</span>

        {/*}
        <div className="">
          <div className="answers-popular-item-body">{this.props.article.text}</div>

          <div className="answers-popular-item-footer">

            <div className="answers-author-avatar">
              <img src="https://imbox.se/wp-content/themes/imbox.se/img/boy128.jpg" />
            </div>

            <div className="answers-meta-info">
              <span className="answers-meta-info-category">In category: Butik</span>
            </div>
          </div>
        </div>
        {**/}

      </li>
    )
  }
}

export {
  Article
}
